export default __webpack_public_path__ + "media/color/deez-c3a4f7d7.svg";